import React, { useEffect } from 'react';
import { Box, LinearProgress } from '@material-ui/core';
import axios from 'axios';

import { useMediaQuery } from 'react-responsive';

import { storeContext } from '../provider/Provider';
import { websiteAnalyticsActions } from '../../store/website-analytics-reducer';
import useStyles from './Backlink.style';

import MobileTitle from '../../customUI/MobileTitle';

import PrimaryContainer from '../../customUI/PrimaryContainer';
import logo from '../../images/logo-2.svg';

const { REACT_APP_FLASK_API_URL } = process.env;

const Backlinks = () => {
  const { state, dispatch } = React.useContext(storeContext);
  const classes = useStyles();

  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  
  useEffect(() => {
    dispatch({
      type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_IS_FETCHING,
      payload: { isFetching: true },
    });
    axios
      .get(`${REACT_APP_FLASK_API_URL}/v1/analytics/${state.websiteSwitch.currentWebsite}`)
      .then((res) => {
        if (!res.data.error) {
          dispatch({
            type: websiteAnalyticsActions.WEBSITE_ANALYTICS_SET_ALL,
            payload: {
              backlinksReport: res.data.data.backlinks_report,
              backlinksEnabled: res.data.data.backlink_report_enabled,
              isFetching: false,
            },
          });
        }
      });
  }, []);
  
  if (state.websiteAnalytics.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  return (
    <>
      {isPhone && <MobileTitle title="Backlinks" />}
      <div className={classes.wrapper}>
        <div className={classes.lead__flex}>
          <Box display='flex' flex={1} flexDirection='column'>
            {state.websiteAnalytics.backlinksReport?.length > 0  && <Box pb={2}>
              <div className={classes.card}>
                <div className={classes.card__wrapper} style={{ height: '90vh'}}>
                  <iframe title='data-studio-desktop' width='100%' style={
                    {
                      display: 'block',
                      position: 'relative',
                      border: 'none',
                    }
                  } height='100%' src={state.websiteAnalytics.backlinksReport} />
                </div>
              </div>
            </Box>}
            {!state.websiteAnalytics.backlinksReport && <PrimaryContainer>
                <div style={{ maxWidth: 1000, margin: 'auto' }}>
                  <div className={classes.center}>
                    <img src={logo} className={classes.topLogo} alt="Hennessey Logo" height="75" />
                  </div>
                  {!state.websiteAnalytics.backlinksEnabled ? <div>
                    <p className={classes.heading}>Give Google more reasons to rank you higher with our Backlink Strategy for SEO</p>
                    <p className={classes.paragraph}>
                      Backlinks are described as &apos;a vote of confidence from one site to another&apos; - and search engines love that when determining where your website ranks in search results.
                    </p>
                    <p className={classes.paragraph}>
                      It&apos;s an important SEO strategy, and why is pretty simple: Google&apos;s algorithm measures the quality and quantity of incoming links (aka backlinks) to your website. Think of them as an endorsement. The more high-quality backlinks you have to your site, the greater your visibility and ranking will be in search results. Your Domain Authority will go up (a win on any search engine), and the number of keywords driving traffic to your site will, too.
                    </p>
                    <p className={classes.paragraph}>
                      It&apos;s a white hat SEO strategy we excel at - and your results are easily found here in the HD Platform.
                    </p>
                    <div className={classes.center}>
                      <p className={classes.bigText} onClick={() => {
                          window.open(
                            'https://hennessey.zendesk.com/hc/en-us/requests',
                            '_blank'
                          );
                        }}
                        role="presentation"
                        style={{ cursor: 'pointer' }}>Contact your Account Manager to get started.</p>
                    </div>
                  </div> : <div style={{ textAlign: "center" }}>
                    <p className={classes.heading}>Backlinks Report is on its way!</p>
                      <p className={classes.paragraph}>
                        In the following days, the Backlinks Report will be available here.
                      </p>
                      <p className={classes.paragraph}>
                        Feel free to reach out to us in case you have any questions related to this.
                      </p>
                      <div className={classes.center}>
                        <p className={classes.bigText} onClick={() => {
                            window.open(
                              'https://hennessey.zendesk.com/hc/en-us/requests',
                              '_blank'
                            );
                          }}
                          role="presentation"
                          style={{ cursor: 'pointer', fontSize: '36px' }}>Contact your Account Manager to get more information.</p>
                      </div>
                  </div>}
                </div>
              </PrimaryContainer>
            }
          </Box>
        </div>
      </div>
    </>
  );
};

export default Backlinks;
